import { useEffect, useState } from "react";
import CommonSelect from "../../core/common/commonSelect";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import api from "../../services/api";
import { showBasicAlert } from "../../core/common/useAlert";
import DeleteModal from "../../core/modals/deleteModal";
import Loader from "../../core/common/loader";

const TicketCategory = () => {
  var initialFormData = {
    name: "",
    status: "",
    company_id: "",
    company_type: "",
    company_name: "",
  };

  const signature = localStorage.getItem("signature");

  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState<any[]>([]);
  //Filter Start
  const [filteredData, setFilteredData] = useState(data);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Ascending");
  const [companies, setCompanies] = useState<any[]>([]);

  //Loding Start
  const [isLoading, setIsLoading] = useState(false); // state to track loading
  //loding end

  //Status Array Start
  const status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  //Status Array End
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  var initialFormDataChooseCompany = {
    company_name: "Select Company",
    company_id: "",
    company_type: "Ticket",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const handleCompanyChanges = async (selectedOption: any) => {
    if (!selectedOption) return;

    const newFormData = {
      company_id: selectedOption.value,
      company_name: selectedOption.label.split("-")[0].trim(),
      company_type: selectedOption.label.split("-")[1].trim(),
    };

    setFormData((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  const handleCompanyChange = async (selectedOption: any) => {
    if (!selectedOption) return;

    const newFormData = {
      company_id: selectedOption.value,
      company_name: selectedOption.label.split("-")[0].trim(),
      company_type: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  useEffect(() => {
    if (
      formDataCompanyChoose?.company_id != "" &&
      formDataCompanyChoose?.company_type
    ) {
      updateUI();
    }
  }, [formDataCompanyChoose]);

  const updateUI = async () => {
    // Making all requests in parallel
    setIsLoading(true);
    const [getCategory] = await Promise.all([
      api.post("raiseTicketsService/getAllTicketCategories", {
        signature,
        company_id: formDataCompanyChoose.company_id,
        company_type: formDataCompanyChoose.company_type,
      }),
    ]);
    setData(getCategory?.data?.data?.data);
    setFilteredData(getCategory?.data?.data?.data);
    setIsLoading(false);
    return;
  };

  useEffect(() => {
    if (companies.length) {
      handleCompanyChange({
        value: companies?.[0]?.id,
        label: companies?.[0]?.name + "-" + companies?.[0]?.type,
      });
    }
  }, [companies]);

  const handleSubmitAddCategories = async (event: any) => {
    event.preventDefault();

    if (
      !formData.name ||
      !formData.status ||
      !formData.company_id ||
      !formData.company_type
    ) {
      showBasicAlert("Please fill all required fields.");
      return;
    }

    try {
      const signature = localStorage.getItem("signature");
      const dataToSend = {
        signature: signature,
        name: formData.name,
        status: formData.status.toLowerCase() === "active" ? 1 : 0,
        company_id: formData.company_id,
        company_type: formData.company_type,
      };
      try {
        setIsSubmitting(true);
        setIsLoading(true);
        const response = await api.post(
          "raiseTicketsService/addTicketCategory",
          dataToSend
        );
        setFormData(initialFormData);
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsSubmitting(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in handleSubmitAddCategories:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  //Edit Departmenmt Start
  const [selectedCategoryEdit, setSelectedCategoryEdit] = useState<any | null>(
    null
  );
  const handleCategoryEdit = (record: any) => {
    try {
      setSelectedCategoryEdit(record);
    } catch (e) {
      console.log(e);
    }
  };

  const handleEditSaveChanges = async () => {
    try {
      // Prepare the payload
      const body = {
        signature: signature,
        name: selectedCategoryEdit.Category,
        status: selectedCategoryEdit.Status === "Active" ? 1 : 0,
        id: selectedCategoryEdit.key,
        company_id: selectedCategoryEdit.CompanyId,
        company_type: selectedCategoryEdit.CompanyType,
      };
      try {
        setIsLoading(true);
        const response = await api.post(
          "raiseTicketsService/updateTicketCategory",
          body
        );
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  //Edit category End
  //Delete category Start
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var category_id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post(
            "raiseTicketsService/deleteTicketCategory",
            {
              signature,
              id: category_id,
            }
          );
          showBasicAlert(response?.data?.message[0]?.msg);
        } catch (error: any) {
          showBasicAlert(error.data.message[0].msg);
        } finally {
          await updateUI();
          setIsLoading(false); // hide loader after response
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };
  //Delete category End
  useEffect(() => {
    fetchUI();
  }, []);
  const fetchUI = async () => {
    // Making all requests in parallel
    setIsLoading(true);
    const [getAllCompanyList] = await Promise.all([
      api.post("userService/getAllCompanyList", { signature }),
    ]);
    setCompanies(getAllCompanyList?.data?.data?.data);
    setIsLoading(false);
    return;
  };

  const companyChoose = [
    ...companies?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
      companyName: company.name,
    })),
  ];

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        ?.filter((item: any) => {
          if (statusFilter && item?.Status !== statusFilter) {
            return false;
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Ascending":
              return a.Category.localeCompare(b.Category);
            case "Descending":
              return b.Category.localeCompare(a.Category);

            default:
              return a.Category.localeCompare(b.Category);
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, sortBy]);

  const handleReset = () => {
    setStatusFilter(null);
  };

  const columns = [
    {
      title: "Ticket Name",
      dataIndex: "Category",
      render: (text: String) => <h6 className="fs-14 fw-medium">{text}</h6>,
      sorter: (a: any, b: any) => a?.Category?.length - b?.Category?.length,
    },
    {
      title: "Company Name",
      dataIndex: "Company",
      render: (text: String) => <h6 className="fs-14 fw-medium">{text}</h6>,
      sorter: (a: any, b: any) => a?.Company?.length - b?.Company?.length,
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: any, record: any) => {
        return (
          <>
            <span
              className={`badge d-inline-flex align-items-center badge-xs ${
                text === "Active"
                  ? "badge-success"
                  : text === "Inactive"
                  ? "badge-danger"
                  : "badge-warning"
              }`}
            >
              <i className="ti ti-point-filled me-1"></i>
              {text}
            </span>
          </>
        );
      },

      sorter: (a: any, b: any) => a?.Status?.length - b?.Status?.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: any, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#edit_ticket"
            onClick={() => handleCategoryEdit(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() => setDeleteRecord(record)}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Ticket Category</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Ticket Category
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.company_id,
                    label:
                      formDataCompanyChoose.company_name +
                      "-" +
                      formDataCompanyChoose.company_type,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_tickets"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add New Category
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Ticket Lists */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Ticket Category List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setStatusFilter("Active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setStatusFilter("Inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Ascending")}
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Descending")}
                      >
                        Descending
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="me-3">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={filteredData}
                key={JSON.stringify(filteredData)}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Ticket */}
      <div className="modal fade" id="add_tickets">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Category</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={isSubmitting} // Disable the close button when submitting
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitAddCategories}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Category Name<span className="text-danger"> *</span>
                      </label>
                      <input
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Company <span className="text-danger"> *</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={companyChoose}
                        defaultValue={{
                          value: formData.company_id,
                          label:
                            formData.company_name + "-" + formData.company_type,
                        }}
                        onChange={handleCompanyChanges}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        {status?.map((data) => (
                          <option key={data.value} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Add Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Ticket */}

      {/* Edit Ticket */}
      <div className="modal fade" id="edit_ticket">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Category</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                {selectedCategoryEdit && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Category Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedCategoryEdit?.Category || ""}
                          onChange={(e) =>
                            setSelectedCategoryEdit((prev: any) => ({
                              ...prev,
                              Category: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                          className="select"
                          options={status}
                          defaultValue={{
                            value: selectedCategoryEdit?.Status,
                            label: selectedCategoryEdit?.Status,
                          }}
                          onChange={(selectedOption: any) =>
                            setSelectedCategoryEdit((prev: any) => ({
                              ...prev,
                              Status: selectedOption?.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleEditSaveChanges}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Ticket */}

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />
    </>
  );
};

export default TicketCategory;
